import React from 'react'
import { Skeleton, Grid } from '@mui/material';

export const EjesSkeleton = () => {

    const array = [1, 2, 3, 4, 5, 6, 7, 8,9,10];

    return (
        <>
            {array.map((num) =>
                <Grid item xs={10} sm={5} lg={2} key={num}>
                    <Skeleton variant='rectangular' sx={{minWidth:'180px',   height: '200px' }} animation="wave" />
                </Grid>
            )}
        </>
    )
}
